import React, { useState } from "react"
import OnBoardingContainer from "../../pages/LandingPage/components/OnBoardingContainer.js"

import TextInput from "../InputBoxes/TextInput"
import FileUpload from "../FileUpload"
import { Button } from "../Buttons"
import Card from "../Card"
import InfoContainer from "./component/InfoContainer.js";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../redux/userSlice.js";
import OnBoardingLeftContainer from "../../pages/LandingPage/components/onBoardingLeftContainer.js";
import EditButton from "../Buttons/EditButton.js";
// import  rightArrowIcon  from "../../assets/Icons/RightIcon.js";
import rightArrowIcon from "../../assets/Images/icons/rightArrowIcon.svg";
const userDetails = {
  name: "Vikram Das",
  pan: "124VDFFFF4G",
  dob: "12/12/1990",
  gender: "Male",
  email: "vikramdas@gmail.com",
  phone: "+91 8422005522",
  address:
    "B-82, Pencil Point Designs, Nariman Point, Near VIdhan Bhanvan, CST, Mumbai",
  pinCode: "400021",
}

const { name, aadharNumber, address, pinCode } = userDetails

const AadharDetails = () => {
  const dispatch = useDispatch()
  const { phoneNumber } = useSelector((state) => state.user)
  const [isFetched, setIsFetched] = useState(false)
  const [aadharNumber, setAadharNumber] = useState("")
  const [aadharFront, setAadharFront] = useState(null)
  const [aadharBack, setAadharBack] = useState(null)
  const [userImage, setUserImage] = useState(null)
  const [error, setError] = useState(false)
  const fetchDetails = () => {
    setIsFetched(true)
  }
  const onUserRejectIdentity = () => {
    setIsFetched(false)
  }

  const onChangeAadharNumber = (text) => {
    setAadharNumber(text.target.value.replace(/\D/g, ""))
    setError(false)
  }

  const isValid = aadharNumber.length === 12 && aadharFront && aadharBack && userImage
  return isFetched ? (
    <OnBoardingContainer
      ComponentFirst={<OnBoardingLeftContainer
        title="Double-Check Your Aadhar Details!"
        description=" Thank you, Vikram, for sharing your Aadhar Card. Correct information
            paves the way for hassle-free services!"
        onBoardingStep={2}
      />
      }

      ComponentSecond={
        <>
          <div className="flex flex-col">
            <Card className="">
              <div className="grid grid-cols-2 gap-[12px] ">
                <InfoContainer
                  title="Aadhar Card Number"
                  value={aadharNumber}
                />
                <InfoContainer title="Name" value={name} />
                <InfoContainer title="Address" value={address} />
                <InfoContainer title="Pin Code" value={pinCode} />
              </div>
            </Card>
            <div className="flexRow mt-[24px] justify-between">
              <div className="flex">
                <Button
                  title="Yes, this is me"
                  onClick={() =>
                    dispatch(
                      setUserData({
                        aadharNumber,
                        name: "XYZ",
                        address: "ABC",
                        pinCode: "1234",
                      })
                    )
                  }
                />
                <span
                  className="flex cursor-pointer justify-center items-center ml-[18px] font-Apparat font-[500] text-[16px] leading-[21px] "
                  onClick={onUserRejectIdentity}
                >
                  No, this is not me
                </span>
              </div>

              <Button variant="tertiary" className=" text-[#424952] px-0">
                <div className="flex items-center justify-center gap-1 text-[#424952]">
                  {" "}
                  <span className="font-[600] text-[16px] leading-[16px] ">
                    Dashboard
                  </span>{" "}
                  <img src={rightArrowIcon} />
                </div>
              </Button>
            </div>
          </div>
        </>
      }
    />
  ) : (
    <>
      <OnBoardingContainer
        ComponentFirst={
          <OnBoardingLeftContainer
            title=" Let’s get you verified!"
            description=" In 3 easy steps, you will get access to out loan products, credit analysis and many more financially empowering tools."
            onBoardingStep={2}
          />
        }

        ComponentSecond={
          <>
            <div className="flex flex-col">
              <p className="font-Apparat font-[600] text-[16px] leading-[24px] mb-[8px]">
                Enter Your Aadhar Card Number <sup className="text-[red]">*</sup>
              </p>
              <TextInput
                placeholder="Aadhar Card no. *"
                onChange={onChangeAadharNumber}
                value={aadharNumber}
                onBlur={() => setError(aadharNumber.length !== 12)}
                error={error ? "Invalid Aadhar Number" : ""}
                pattern="[0-9]*"
                maxLength={12}
              />

              <p className="font-Apparat font-[600] text-[16px] leading-[24px] mb-[8px] mt-[40px]">
                Add the photo <sup className="text-[red]">*</sup>  <span className="text-[#A0A4A8]">(Max File size: 2MB)</span>
              </p>
              <div className="grid grid-cols-2 justify-between gap-[24px]">
                <FileUpload
                  title="Aadhar Card Front"
                  acceptValue="image/*"
                  preview={aadharFront?.preview}
                  onSelect={setAadharFront}
                  maxSize={2}
                />
                <FileUpload
                  title="Aadhar Card Back"
                  acceptValue="image/*"
                  preview={aadharBack?.preview}
                  onSelect={setAadharBack}
                  maxSize={2}
                />
              </div>
              <p className="font-Apparat font-[600] text-[16px] leading-[24px] mb-[8px] mt-[40px]">
                Add the photo <sup className="text-[red]">*</sup> <span className="text-[#A0A4A8]">(Max File size: 2MB)</span>
              </p>
              <div className="grid grid-cols-2 justify-between gap-[24px]">
                <FileUpload
                  title="Take a Selfie"
                  preview={userImage?.preview}
                  onSelect={setUserImage}
                  acceptValue="image/*"
                  maxSize={2}
                />
              </div>
              <div className="flex justify-between items-center mt-[24px]">
                <Button
                  title="Fetch"
                  onClick={() => fetchDetails()}

                  disabled={!isValid}
                />

                <Button variant="tertiary" className=" text-[#424952]">
                  <div className="flex items-center justify-center gap-1 text-[#424952]">
                    {" "}
                    <span className="font-[600] text-[16px] leading-[16px] ">
                      Dashboard
                    </span>{" "}
                    <img src={rightArrowIcon} />
                  </div>
                </Button>
              </div>
            </div>
          </>
        }
      />
    </>
  )
}

export default AadharDetails
